module.exports = __webpack_public_path__ + "img/entrepreneur.97b5bb6f.svg";